module.exports = __webpack_public_path__ + "static/media/dashboard.611b06ac.svg";